(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxOcrLanguageDialog(
    $timeout, $filter, toastr, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        mode: '=mode',
        OCR_LANGUAGES_RAW: '=ocrLanguages',
        wfModel: "=wfModel",
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/workflows/ocrLanguageDialog/ocrLanguageDialog.template.html',
      link: function(scope) {

        const fileType = scope.wfModel.fileType
        scope.OCR_LANGUAGES = [];
        scope.SELECTED_OCR_LANGUAGES = [];
        const ACTIVITY_OCR_LANGUAGES = scope.wfModel.ocrConfiguration.languages.map(lang => lang);

        (function() {
          sortOCRLanguages()
        })();


        function sortOCRLanguages () {
          scope.SELECTED_OCR_LANGUAGES = scope.OCR_LANGUAGES_RAW.reduce((acc, key) => {
            if (ACTIVITY_OCR_LANGUAGES.includes(key.id)) {
              key.isSelected = true;
              acc.push(key)
            }
            return acc;
          }, [])

          scope.OCR_LANGUAGES = scope.OCR_LANGUAGES_RAW.reduce((acc, key) => {
            if (!ACTIVITY_OCR_LANGUAGES.includes(key.id)) {
              key.isSelected = false;
              acc.push(key)
            }
            return acc;
          }, [])

        }

        scope.toggleSelect = function (event, language) {
          event.preventDefault();
          language.isSelected = !language.isSelected;
          if (language.isSelected) {
            ACTIVITY_OCR_LANGUAGES.push(language.id);
            sortOCRLanguages()
          } else {
            ACTIVITY_OCR_LANGUAGES.splice(ACTIVITY_OCR_LANGUAGES.indexOf(language.id), 1);
            sortOCRLanguages()
          }
        }

        scope.close = function () {
          scope.callback();
        }

        scope.keepSelectedOCRLanguages = function () {
          scope.wfModel.ocrConfiguration.languages = ACTIVITY_OCR_LANGUAGES;
          scope.callback();
        }

        scope.$on('$destroy', function() {
        });

      }
    };
  }

  pxOcrLanguageDialog.$inject = ['$timeout', '$filter', 'toastr', '$http'];

  angular
    .module('printix-admin')
    .directive('pxOcrLanguageDialog', pxOcrLanguageDialog);

})();
